import { HuddleClient } from "@huddle01/react";

let _client: HuddleClient | null = null;

/**
 * Lazy HuddleClient singleton. The web + desktop renderers share a single
 * instance per process — Huddle01 keeps a websocket open per client, so
 * spinning up multiple would burn sockets and confuse the SDK's room
 * lifecycle handlers.
 *
 * `projectId` is captured on first call and treated as immutable; if a
 * caller passes a different id after the singleton is established we
 * keep the original (changing project ids mid-session isn't a real use
 * case and silently re-keying would leak the old socket).
 */
export function getHuddleClient(projectId: string): HuddleClient {
  if (!_client) {
    _client = new HuddleClient({
      projectId,
      options: {
        activeSpeakers: {
          size: 12,
        },
      },
    });
  }
  return _client;
}

/** Test/HMR helper — drop the singleton so the next getHuddleClient() rebuilds. */
export function resetHuddleClient(): void {
  _client = null;
}
